/** Čistá matematika resize splitteru mezi dvěma flex sourozenci podél hlavní osy.
 *  Přerozdělí jejich prostor (basis v % kontejneru), součet zachová, respektuje min limity. Testovatelné bez DOM. */

export const clamp = (v: number, lo: number, hi: number): number => Math.max(lo, Math.min(hi, v));

/**
 * Z aktuálních pixelových velikostí dvou sourozenců (aPx, bPx), posunu splitteru (deltaPx) a šířky/výšky
 * kontejneru (containerPx) spočítá nové `basis` v procentech. Součet aNew+bNew = aPx+bPx (prostor se jen
 * přerozdělí). Min limity (px) brání kolapsu pod čitelnou velikost.
 */
export const resizePair = (
  aPx: number,
  bPx: number,
  deltaPx: number,
  containerPx: number,
  minAPx = 24,
  minBPx = 24
): { aBasis: string; bBasis: string } => {
  const total = aPx + bPx;
  const safeContainer = containerPx > 0 ? containerPx : total > 0 ? total : 1;
  const hiA = Math.max(minAPx, total - minBPx); // aby b nekleslo pod minBPx
  const aNew = clamp(aPx + deltaPx, minAPx, hiA);
  const bNew = total - aNew;
  const pct = (px: number): string => `${((px / safeContainer) * 100).toFixed(2)}%`;
  return { aBasis: pct(aNew), bBasis: pct(bNew) };
};
